
/*
 *  Adds current url as a referrer attribute to user session links
 */
module.exports = Groupon.SharedJS.addReferrer = (function() {
  return {
    init: function() {
      var current_href, flags, ref1, referrer, selector;
      selector = '';
      flags = (ref1 = Groupon.PageFlags) != null ? ref1 : {};
      selector = flags.isTouch ? '#t-sign-in, #t-sign-out, .t-login-button' : '#ls-user-signin, #ls-user-signup, #sign-out';
      current_href = location.href;
      current_href = current_href.replace(location.hash, '');
      current_href = current_href.replace(/[?&](ref|return_to)=([^&]*)?/, '');
      referrer = 'return_to=' + encodeURIComponent(current_href);
      return $(selector).each(function() {
        var ref;
        ref = /\?/.test(this.href) ? '&' : '?';
        ref += referrer;
        return this.href += ref;
      });
    }
  };
})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9zaGFyZWQvdXNlclNlc3Npb25BZGRSZWZlcnJlci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9jb3JlL2Zyb250ZW5kL3NoYXJlZC91c2VyU2Vzc2lvbkFkZFJlZmVycmVyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7OztBQUdBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLE9BQU8sQ0FBQyxRQUFRLENBQUMsV0FBakIsR0FBa0MsQ0FBQSxTQUFBO1NBQ2pEO0lBQUEsSUFBQSxFQUFNLFNBQUE7QUFDSixVQUFBO01BQUEsUUFBQSxHQUFXO01BQ1gsS0FBQSwrQ0FBNEI7TUFFNUIsUUFBQSxHQUNLLEtBQUssQ0FBQyxPQUFULEdBQ0UsMENBREYsR0FHRTtNQUVKLFlBQUEsR0FBZSxRQUFRLENBQUM7TUFHeEIsWUFBQSxHQUFlLFlBQVksQ0FBQyxPQUFiLENBQXFCLFFBQVEsQ0FBQyxJQUE5QixFQUFvQyxFQUFwQztNQUdmLFlBQUEsR0FBZSxZQUFZLENBQUMsT0FBYixDQUFxQiw4QkFBckIsRUFBcUQsRUFBckQ7TUFFZixRQUFBLEdBQVcsWUFBQSxHQUFlLGtCQUFBLENBQW1CLFlBQW5CO2FBQzFCLENBQUEsQ0FBRSxRQUFGLENBQVcsQ0FBQyxJQUFaLENBQWlCLFNBQUE7QUFDZixZQUFBO1FBQUEsR0FBQSxHQUFTLElBQUksQ0FBQyxJQUFMLENBQVUsSUFBQyxDQUFBLElBQVgsQ0FBSCxHQUF5QixHQUF6QixHQUFrQztRQUN4QyxHQUFBLElBQU87ZUFDUCxJQUFDLENBQUEsSUFBRCxJQUFTO01BSE0sQ0FBakI7SUFuQkksQ0FBTjs7QUFEaUQsQ0FBQSxDQUFILENBQUEifQ==
